module.exports = __webpack_public_path__ + "img/12-2.092d79d6.jpg";